<template>
    <div>
        <!--HEADER NAVBAR START-->
        <SiteHeader style="width: 100%"></SiteHeader>
        <NavbarStatic style="width: 100%"></NavbarStatic>
        <!--HEADER NAVBAR END-->

        <!--CONTENTS START-->
        <div style="margin-bottom: 50px;">
            <el-carousel :interval="6500" indicator-position="outside" :height="isWindowOnDesktop ? '900px' : '250px'">
                <template v-for="(pic, index) in content.pictures">
                    <el-carousel-item>
                        <div class="carousel-item-container">
                            <img :src="pic.full_path" class="carousel-image" />
                            <div class="carousel-overlay">
                                <div class="carousel-text">
                                    <h4 class="carousel-featured">What's Happening at St. Scho</h4>
                                    <h2 class="carousel-title">{{ content.title }}</h2>
                                    <p class="carousel-author">By {{ content.author }} | {{ content.date }}</p>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </template>
            </el-carousel>
        </div>

        <div class="container-fluid" style="margin-bottom: 50px;">
            <div class="row no-gutters">
                <div class="col-md-8" style="margin-right: 100px;">
                    <span v-html="content.content"></span>
                </div>
                <div class="col-md-2">
                    <div class="sidebar-container" v-if="recentlyAdded != null">
                        <!-- Recently Added Section -->
                        <div class="sidebar-section">
                            <h2 class="sidebar-title">RECENTLY ADDED</h2>
                            <div class="sidebar-card">
                                <img :src="recentlyAdded.cover_picture" class="sidebar-image" />
                                <div class="sidebar-content">
                                    <h3 class="sidebar-card-title">{{ recentlyAdded.title }}</h3>
                                    <p class="sidebar-card-author">{{ recentlyAdded.author }} | {{ recentlyAdded.date }}</p>
                                    <a :href="env_wp.APP_URL+'/news/featured/'+recentlyAdded.slug" class="sidebar-read-more">Read more <i class="fa fa-arrow-right"></i></a>
                                </div>
                            </div>
                        </div>

                        <!-- Upcoming Events Section -->
                        <div class="sidebar-section" v-if="upcomingEvent !== null">
                            <h2 class="sidebar-title">Upcoming Events</h2>
                            <div class="sidebar-card">
                                <img :src="upcomingEvent.cover_picture" class="sidebar-image" />
                                <div class="sidebar-content">
                                    <h3 class="sidebar-card-title">{{ upcomingEvent.title }}</h3>
                                    <p class="sidebar-card-author">{{ upcomingEvent.date }}</p>
                                    <template v-if="upcomingEvent.type == 1">
                                        <a :href="env_wp.APP_URL+'/news/upcoming/'+upcomingEvent.slug" class="sidebar-read-more">Learn more <i class="fa fa-arrow-right"></i></a>
                                    </template>
                                    <template v-else>
                                        <a :href="upcomingEvent.link" class="sidebar-read-more" target="_blank">Learn more <i class="fa fa-facebook"></i></a>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--CONTENTS END-->

        <!--FOOTER START-->
        <div style="margin-top: 20px; margin-bottom: 20px;">
            <div class="row no-gutters" :style="!isWindowOnDesktop ? 'margin-left: 0; margin-right: 0;' : ''">
                <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" style="padding-right: 0px;">
                    &nbsp;
                </div>
                <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" :style="!isWindowOnDesktop ? 'padding-right: 0px;' : ''">
                    <button @click="scrollToTop()" class="btn btn-ssa pull-right"><span style="font-family: Arial; font-size: 2rem; color: #ffffff;"><strong><i class="fa fa-angle-double-up" aria-hidden="true"></i>Back to Top</strong></span></button>
                </div>
            </div>
        </div>
        
        <div style="background: #012376;">
            <div class="row" style="margin-right: 0%;">
                &nbsp;
            </div>
        </div>
        <SiteFooter :style="{backgroundImage: `url('${env_wp.APP_URL}/public/assets/img/ssa_manila/hompage/footer_assets/comp/footer_backdrop.png')`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', position: 'relative', width: '100%'}"></SiteFooter>
        <!--FOOTER END-->
    </div>
</template>
<style scoped>
    .carousel-item-container {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    /* Carousel Image */
    .carousel-image {
        width: 100%;
        height: 100%;
        object-fit: fill;
    }

    /* Overlay */
    .carousel-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8));
        display: flex;
        align-items: flex-end; /* Align text to the bottom */
        justify-content: flex-start;
        padding: 40px 20px; /* Increase top padding to move text lower */
        box-sizing: border-box;
    }

    /* Text Container */
    .carousel-text {
        color: #012376;
        max-width: 50%;
    }

    /* Featured Label */
    .carousel-featured {
        font-size: 1.2rem;
        font-weight: bold;
        color: #012376;
        margin-bottom: 10px;
    }

    /* Title */
    .carousel-title {
        font-size: 2rem;
        font-weight: bold;
        line-height: 1.4;
        margin-bottom: 15px;
    }

    /* Author and Date */
    .carousel-author {
        font-size: 1rem;
        margin-bottom: 20px;
        color: #012376;
    }

    /* Read More Link */
    .carousel-read-more {
        font-size: 1rem;
        font-weight: bold;
        color: #012376;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
    }

    .carousel-read-more i {
        margin-left: 5px;
        font-size: 1rem;
    }

    .el-carousel__item h3 {
        display: block;
        color: #012376;
        opacity: 5;
        line-height: 300px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #012376;
    }

    .el-carousel__item:nth-child(2n + 1) {
        background-color: #012376;
    }
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: auto;
        height: auto;
        background-color: #012376;
        border-radius: 20px;
        opacity: 75%;
    }

    .centered-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 16px;
        font-weight: bold;
        z-index: 1;
    }
    .btn-ssa{
        background-color: #012376;
    }

    .image-container {
        -webkit-mask-image: linear-gradient(to bottom, white 0%, transparent 100%);
       mask-image: linear-gradient(to bottom, white 0%, transparent 100%);
       -webkit-mask-size: 100% 100%;
       mask-size: 100% 100%;
       -webkit-mask-repeat: no-repeat;
       mask-repeat: no-repeat;
    }

    .overlay {
       -webkit-mask-image: linear-gradient(to bottom, white 0%, white 100%, transparent 100%);
       mask-image: linear-gradient(to bottom, white 0%, white 100%, transparent 100%);
       -webkit-mask-size: 100% 100%;
       mask-size: 100% 100%;
       -webkit-mask-repeat: no-repeat;
       mask-repeat: no-repeat;
    }

    .carousel-container {
        margin-top: 20px;
        margin-bottom: 50px;
        text-align: center;
    }

    .section-title {
        font-size: 2rem;
        font-weight: bold;
        color: #012376;
        margin-bottom: 20px;
    }

    .happening-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #f8fafc;
        /* border-radius: 0px; */
        overflow: hidden;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        padding: 20px;
    }

    .happening-image {
        width: 50%;
        height: auto;
        /* border-radius: 10px; */
        object-fit: cover;
    }

    .happening-content {
        width: 45%;
        text-align: left;
        padding: 20px;
    }

    .happening-title {
        font-size: 1.5rem;
        font-weight: bold;
        color: #012376;
        margin-bottom: 10px;
    }

    .happening-author {
        font-size: 1rem;
        /* color: #555555; */
        margin-bottom: 20px;
    }

    .happening-read-more {
        font-size: 1rem;
        font-weight: bold;
        color: #012376;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
    }

    .happening-read-more i {
        margin-left: 5px;
        font-size: 1rem;
    }

    .upcoming-events-container {
        margin-top: 20px;
        margin-bottom: 50px;
        text-align: center;
    }

    .section-title {
        font-size: 2rem;
        font-weight: bold;
        color: #012376;
        margin-bottom: 20px;
    }

    .events-list {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .event-item {
        display: flex;
        align-items: center;
        background-color: #ffffff;
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        padding: 20px;
    }

    .event-date {
        background-color: #012376;
        color: #ffffff;
        text-align: center;
        padding: 10px 20px;
        border-radius: 10px;
        margin-right: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-width: 80px;
    }

    .event-day {
        font-size: 2rem;
        font-weight: bold;
        margin: 0;
    }

    .event-month {
        font-size: 1rem;
        text-transform: uppercase;
        margin: 0;
    }

    .event-details {
        flex: 1;
        text-align: left;
    }

    .event-title {
        font-size: 1.5rem;
        font-weight: bold;
        color: #012376;
        margin-bottom: 10px;
    }

    .event-description {
        font-size: 1rem;
        color: #555555;
        margin-bottom: 20px;
    }

    .event-footer {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .learn-more {
        font-size: 1rem;
        font-weight: bold;
        color: #012376;
        text-decoration: none;
    }

    .facebook-link {
        font-size: 1.5rem;
        color: #012376;
        text-decoration: none;
    }
    .event-image {
        height: auto;
        width: auto;
        padding-left: 25px;
        padding-right: 25px;
    }

    .sidebar-container {
    display: flex;
    flex-direction: column;
    gap: 10px; /* Reduced gap between sections */
}

.sidebar-section {
    background-color: #ffffff;
    border-radius: 6px; /* Smaller border radius */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); /* Reduced shadow */
    padding: 10px; /* Reduced padding */
    text-align: center;
}

.sidebar-title {
    font-size: 1rem; /* Smaller font size */
    font-weight: bold;
    color: #012376;
    margin-bottom: 10px; /* Reduced margin */
    text-align: left;
    border-bottom: 1px solid #012376; /* Thinner border */
    padding-bottom: 5px; /* Reduced padding */
}

.sidebar-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px; /* Reduced gap between elements */
}

.sidebar-image {
    width: 80%; /* Smaller image width */
    height: auto;
    border-radius: 6px; /* Smaller border radius */
    object-fit: cover;
}

.sidebar-content {
    text-align: left;
    width: 100%;
}

.sidebar-card-title {
    font-size: 0.9rem; /* Smaller font size */
    font-weight: bold;
    color: #012376;
    margin-bottom: 5px; /* Reduced margin */
}

.sidebar-card-author {
    font-size: 0.7rem; /* Smaller font size */
    color: #555555;
    margin-bottom: 8px; /* Reduced margin */
}

.sidebar-read-more {
    font-size: 0.8rem; /* Smaller font size */
    font-weight: bold;
    color: #012376;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
}

.sidebar-read-more i {
    margin-left: 3px;
    font-size: 0.8rem; /* Smaller icon size */
}

</style>
<script>
    import NavbarStatic from "../../../../components/general/NavbarStatic";
    import SiteHeader from "../../../../components/general/SiteHeader";
    import SiteFooter from "../../../../components/general/SiteFooter";
import { env } from "process";
    export default {
        props: {
            content: Object,
        },
        components: { NavbarStatic,SiteHeader,SiteFooter },
        data () {
            return {
                folder_name: this.$root.folder_name,
                env_wp: this.$root.env_wp.env_wp,
                screenWidth: window.innerWidth,
                isWindowOnDesktop: window.innerWidth > 768,
                recentlyAdded: {},
                upcomingEvent: {},
            }
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            });
            this.onResize();
            this.getSideContents();
        },
        created() {

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        watch: {
            screenWidth(width) {
                this.isWindowOnDesktop = width > 768;
            },
        },
        methods: {
            scrollToTop(){
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            onResize() {
                this.screenWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            },
            getSideContents(){
                axios.get(this.env_wp.APP_URL + '/news/get_side_contents')
                .then(res => {
                    this.recentlyAdded = res.data.recently_added;
                    this.upcomingEvent = res.data.upcoming_event;
                })
                .catch(err => {
                    console.log(err);
                });
            },
        }
    }
</script>